document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('[data-countdown]').forEach(el=>{const target=new Date(el.dataset.countdown).getTime();const tick=()=>{const d=Math.max(0,target-Date.now());const vals=[Math.floor(d/86400000),Math.floor(d/3600000)%24,Math.floor(d/60000)%60,Math.floor(d/1000)%60];el.querySelectorAll('[data-time]').forEach((n,i)=>n.textContent=String(vals[i]).padStart(2,'0'))};tick();setInterval(tick,1000)});document.querySelectorAll('.hotspot__button').forEach(btn=>btn.addEventListener('click',()=>{const item=btn.closest('.lookbook__hotspot');const open=item.classList.toggle('is-open');btn.setAttribute('aria-expanded',open)}));document.querySelectorAll('.nav-item--mega>.nav-link').forEach(link=>link.addEventListener('click',e=>{if(matchMedia('(max-width:989px)').matches){const item=link.parentElement;if(!item.classList.contains('is-mega-open')){e.preventDefault();document.querySelectorAll('.nav-item.is-mega-open').forEach(x=>x!==item&&x.classList.remove('is-mega-open'));item.classList.add('is-mega-open');link.setAttribute('aria-expanded','true')}}}));document.querySelectorAll('[data-product-root]').forEach(root=>{const slides=[...root.querySelectorAll('[data-gallery-slide]')],thumbs=[...root.querySelectorAll('[data-gallery-thumb]')],viewer=root.querySelector('[data-product-viewer]');let active=0;const show=i=>{if(!slides.length)return;active=(i+slides.length)%slides.length;slides.forEach((x,n)=>x.classList.toggle('is-active',n===active));thumbs.forEach((x,n)=>x.classList.toggle('is-active',n===active))};thumbs.forEach((x,i)=>{x.addEventListener('mouseenter',()=>show(i));x.addEventListener('focus',()=>show(i));x.addEventListener('click',()=>show(i))});root.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>show(active-1));root.querySelector('[data-gallery-next]')?.addEventListener('click',()=>show(active+1));root.querySelectorAll('[data-grid-image]').forEach(x=>x.addEventListener('click',()=>{show(Number(x.dataset.index));viewer?.scrollIntoView({behavior:'smooth',block:'center'})}));viewer?.addEventListener('mousemove',e=>{const r=viewer.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;const img=viewer.querySelector('.product-viewer__slide.is-active img');if(img)img.style.transform=`rotateY(${x*3}deg) rotateX(${-y*3}deg) scale(1.012)`});viewer?.addEventListener('mouseleave',()=>{const img=viewer.querySelector('.product-viewer__slide.is-active img');if(img)img.style.transform=''});const variants=JSON.parse(root.querySelector('[data-product-variants]')?.textContent||'[]'),idInput=root.querySelector('[data-variant-id]'),price=root.querySelector('[data-product-price]');const updatePDPPriceAndMRP = (variant) => {
  if (!variant) return;
  const vPriceCents = Number(variant.price);
  const vPriceNum = vPriceCents / 100;
  const vPriceStr = (vPriceNum % 1 === 0) ? vPriceNum.toFixed(0) : vPriceNum.toFixed(2);
  if (price) price.textContent = '₹ ' + vPriceStr;

  const mrpRow = root.querySelector('.pdp-price-line-2');
  if (variant.compare_at_price && Number(variant.compare_at_price) > vPriceCents) {
    const vMrpCents = Number(variant.compare_at_price);
    const vMrpNum = vMrpCents / 100;
    const vMrpStr = (vMrpNum % 1 === 0) ? vMrpNum.toFixed(0) : vMrpNum.toFixed(2);
    const savingsAmt = vMrpCents - vPriceCents;
    const savingsPct = Math.round((savingsAmt * 100) / vMrpCents);

    if (mrpRow) {
      mrpRow.innerHTML = '<span class="mrp-label-lg">M.R.P.: <s>₹ ' + vMrpStr + '</s></span><span class="discount-percent-tag">(' + savingsPct + '% off)</span>';
      mrpRow.style.setProperty('display', 'flex', 'important');
    }
  } else {
    if (mrpRow) {
      mrpRow.innerHTML = '';
      mrpRow.style.setProperty('display', 'none', 'important');
    }
  }

  const unitEl = root.querySelector('.unit-price-label-lg');
  if (variant.unit_price_measurement) {
    const uPriceNum = Number(variant.unit_price) / 100;
    const uPriceStr = (uPriceNum % 1 === 0) ? uPriceNum.toFixed(0) : uPriceNum.toFixed(2);
    const uVal = variant.unit_price_measurement.reference_value || '';
    const uUnit = variant.unit_price_measurement.reference_unit || '';
    if (unitEl) unitEl.textContent = '(₹ ' + uPriceStr + ' / ' + uVal + uUnit + ')';
  } else {
    let weightG = Number(variant.weight) || 0;
    if (weightG <= 0) {
      const vStr = [variant.title, variant.option1, variant.option2, variant.option3].filter(Boolean).join(' ');
      const kgMatch = vStr.match(/(\d+(?:\.\d+)?)\s*kg/i);
      if (kgMatch) {
        weightG = Math.round(parseFloat(kgMatch[1]) * 1000);
      } else {
        const gMatch = vStr.match(/(\d+)\s*g/i);
        if (gMatch) {
          weightG = parseInt(gMatch[1], 10);
        }
      }
    }
    if (weightG <= 0) {
      const pTitle = document.querySelector('h1')?.textContent || '';
      const packMatch = pTitle.match(/pack\s+of\s+(\d+).*?(\d+)\s*g/i);
      if (packMatch) {
        weightG = parseInt(packMatch[1], 10) * parseInt(packMatch[2], 10);
      } else {
        const kgMatch = pTitle.match(/(\d+(?:\.\d+)?)\s*kg/i);
        if (kgMatch) {
          weightG = Math.round(parseFloat(kgMatch[1]) * 1000);
        } else {
          const gMatch = pTitle.match(/(\d+)\s*g/i);
          if (gMatch) {
            weightG = parseInt(gMatch[1], 10);
          }
        }
      }
    }
    if (weightG <= 0) weightG = 400;

    const rawUnitCents = Math.round((vPriceCents * 100) / weightG);
    const unitPriceNum = rawUnitCents / 100;
    const unitStr = (unitPriceNum % 1 === 0) ? unitPriceNum.toFixed(0) : unitPriceNum.toFixed(1);
    if (unitEl) unitEl.textContent = '(₹ ' + unitStr + ' / 100g)';
  }

  // Dynamic Stock Status Badge & Add To Cart Button Toggle
  const stockBadge = root.querySelector('.stock-status-badge');
  const atcBtn = root.querySelector('.product-atc');
  const buyNowWrap = root.querySelector('.premium-buy-now');

  const isAvail = Boolean(
    variant.available && 
    variant.available !== 'false' && 
    variant.available !== false &&
    (variant.inventory_quantity === undefined || variant.inventory_quantity === null || Number(variant.inventory_quantity) > 0 || variant.inventory_policy === 'continue' || !variant.inventory_management)
  );

  if (isAvail) {
    if (stockBadge) {
      stockBadge.style.display = 'inline-flex';
      stockBadge.className = 'stock-status-badge stock-status--in';
      stockBadge.innerHTML = '<span class="stock-dot"></span><span>In stock (Fresh Batch Ready)</span>';
    }
    if (atcBtn) {
      atcBtn.textContent = 'Add to cart';
      atcBtn.disabled = false;
      atcBtn.style.opacity = '1';
      atcBtn.style.cursor = 'pointer';
    }
    if (buyNowWrap) {
      buyNowWrap.style.display = 'block';
    }
  } else {
    if (stockBadge) {
      stockBadge.style.display = 'inline-flex';
      stockBadge.className = 'stock-status-badge stock-status--out';
      stockBadge.innerHTML = '<span class="stock-dot stock-dot--red"></span><span>Out of Stock</span>';
    }
    if (atcBtn) {
      atcBtn.textContent = '🔔 Update Me';
      atcBtn.className = 'button product-atc button--update-me';
      atcBtn.disabled = false;
      atcBtn.style.opacity = '1';
      atcBtn.style.cursor = 'pointer';
      atcBtn.setAttribute('type', 'button');
      atcBtn.setAttribute('data-trigger-restock-btn', 'true');
    }
    if (buyNowWrap) {
      buyNowWrap.style.display = 'none';
    }
  }
};


    const initialVariant = variants.find(v => v.id == idInput?.value) || variants[0];
    if (initialVariant) updatePDPPriceAndMRP(initialVariant);

    root.querySelectorAll('[data-option-value]').forEach(btn => btn.addEventListener('click', () => {
  const fieldset = btn.closest('.product-option');
  if (fieldset) {
    fieldset.querySelectorAll('[data-option-value]').forEach(x => x.classList.remove('is-selected'));
    btn.classList.add('is-selected');
  } else {
    root.querySelectorAll('[data-option-value]').forEach(x => x.classList.remove('is-selected'));
    btn.classList.add('is-selected');
  }

  const selectedOptions = [...root.querySelectorAll('.option-pill.is-selected')].map(x => x.dataset.optionValue);
  let variant = variants.find(v => {
    return selectedOptions.every(opt => v.options?.includes(opt));
  });
  if (!variant) {
    variant = variants.find(v => v.options?.includes(btn.dataset.optionValue));
  }

  if (variant) {
    if (idInput) idInput.value = variant.id;
    updatePDPPriceAndMRP(variant);
  }
}));const qty=root.querySelector('[data-quantity-input]'),custom=root.querySelector('[data-custom-qty]'),customWrap=custom?.closest('.quantity-custom');root.querySelectorAll('[data-qty]').forEach(btn=>btn.addEventListener('click',()=>{root.querySelectorAll('[data-qty]').forEach(x=>x.classList.remove('is-selected'));customWrap?.classList.remove('is-selected');btn.classList.add('is-selected');qty.value=btn.dataset.qty;if(custom)custom.value=''}));const updateCustomQty=()=>{root.querySelectorAll('[data-qty]').forEach(x=>x.classList.remove('is-selected'));if(custom.value&&Number(custom.value)>0){customWrap?.classList.add('is-selected');qty.value=Number(custom.value);}else{customWrap?.classList.remove('is-selected');qty.value=1;}};custom?.addEventListener('input',updateCustomQty);custom?.addEventListener('focus',updateCustomQty);});document.addEventListener('click',e=>{if(!e.target.closest('.lookbook__hotspot'))document.querySelectorAll('.lookbook__hotspot.is-open').forEach(x=>x.classList.remove('is-open'));if(!e.target.closest('.nav-item'))document.querySelectorAll('.nav-item.is-mega-open').forEach(x=>x.classList.remove('is-mega-open'))})});
document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('[data-mega-slider]').forEach((slider,sliderIndex)=>{const slides=[...slider.querySelectorAll('.category-card-slide, .mega-card-slide')];if(slides.length<2)return;let index=0;setInterval(()=>{slides[index].classList.remove('is-active');index=(index+1)%slides.length;slides[index].classList.add('is-active')},2300+sliderIndex*240)})});

/* --- D2C CART DRAWER & PRODUCT DEMAND REQUEST ENGINE --- */
document.addEventListener('DOMContentLoaded', () => {
  const formatMoney = (cents) => {
    const amt = (cents / 100).toFixed(2);
    return '₹ ' + amt;
  };

  const cartDialog = document.querySelector('[data-cart-dialog]');
  const toast = document.getElementById('CartDropdownToast');
  const toastName = toast?.querySelector('[data-toast-item-name]');
  const toastClose = toast?.querySelector('[data-toast-close]');
  let toastTimer = null;

  const showToast = (itemName) => {
    const toastEl = document.getElementById('CartDropdownToast') || toast;
    if (!toastEl) return;
    const toastNameEl = toastEl.querySelector('[data-toast-item-name]');
    if (toastNameEl) toastNameEl.textContent = itemName || 'Item added to cart';
    toastEl.classList.add('is-active');
    toastEl.setAttribute('aria-hidden', 'false');

    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      toastEl.classList.remove('is-active');
      toastEl.setAttribute('aria-hidden', 'true');
    }, 4000);
  };

  toastClose?.addEventListener('click', () => {
    toast.classList.remove('is-active');
    toast.setAttribute('aria-hidden', 'true');
  });

  const openCartDrawer = () => {
    if (cartDialog && typeof cartDialog.showModal === 'function') {
      if (!cartDialog.open) cartDialog.showModal();
    } else if (cartDialog) {
      cartDialog.setAttribute('open', '');
    }
  };

  const refreshCartDrawer = () => {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        document.querySelectorAll('.cart-count').forEach(cnt => cnt.textContent = cart.item_count);
        const rawThreshold = (typeof window.freeShippingThreshold !== 'undefined' && window.freeShippingThreshold !== null) ? Number(window.freeShippingThreshold) : 0;
        const threshold = isNaN(rawThreshold) ? 0 : (rawThreshold * 100);
        const shippingBar = document.querySelector('[data-shipping-bar]');
        if (shippingBar) {
          if (threshold <= 0 || cart.total_price >= threshold) {
            shippingBar.innerHTML = '<p class="shipping-msg shipping-msg--success">🎉 You have unlocked <strong>FREE Shipping</strong> across India!</p><div class="shipping-progress"><span style="width: 100%;"></span></div>';
          } else {
            const needed = formatMoney(threshold - cart.total_price);
            const pct = Math.min(100, Math.round((cart.total_price * 100) / threshold));
            shippingBar.innerHTML = '<p class="shipping-msg">Add <strong>' + needed + '</strong> more for <strong>FREE Shipping</strong></p><div class="shipping-progress"><span style="width: ' + pct + '%;"></span></div>';
          }
        }

        const cartPageShipping = document.querySelector('.summary-shipping-info');
        if (cartPageShipping) {
          if (threshold <= 0 || cart.total_price >= threshold) {
            cartPageShipping.innerHTML = '<div class="summary-shipping-badge shipping-badge--free"><span>✨ FREE Shipping Included Across India</span></div>';
          } else {
            const needed = formatMoney(threshold - cart.total_price);
            cartPageShipping.innerHTML = '<div class="summary-shipping-badge shipping-badge--needed"><span>🚚 Add ' + needed + ' more for <strong>FREE Shipping</strong></span></div>';
          }
        }
        const cartSummaryVal = document.querySelector('.summary-value');
        if (cartSummaryVal) {
          cartSummaryVal.textContent = formatMoney(cart.total_price);
        }

        const itemsWrap = document.querySelector('[data-cart-items]');
        if (itemsWrap) {
          if (cart.item_count === 0) {
            itemsWrap.innerHTML = `
              <div class="drawer-empty">
                <div class="drawer-empty-icon">🛒</div>
                <h3>Your cart is empty</h3>
                <p>Explore our classic gajak, chikki and festive gift boxes.</p>
                <a href="/collections/all" class="button">Shop our range</a>
              </div>`;
          } else {
            itemsWrap.innerHTML = cart.items.map(item => `
              <div class="drawer-cart-card" data-line-item-key="${item.key}">
                <div class="drawer-cart-card__media">
                  ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : `<div style="width:100%;height:100%;background:#f4eee4"></div>`}
                </div>
                <div class="drawer-cart-card__info">
                  <div class="drawer-cart-card__head">
                    <a href="${item.url}" class="drawer-cart-card__title">${item.product_title || item.title}</a>
                    <button type="button" class="drawer-cart-card__remove" data-cart-remove="${item.key}" aria-label="Remove item">✕</button>
                  </div>
                  ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="drawer-cart-card__variant">${item.variant_title}</p>` : ''}
                  <div class="drawer-cart-card__foot">
                    <div class="drawer-cart-qty">
                      <button type="button" data-qty-change="-1" data-key="${item.key}" data-qty="${item.quantity}">−</button>
                      <span>${item.quantity}</span>
                      <button type="button" data-qty-change="1" data-key="${item.key}" data-qty="${item.quantity}">+</button>
                    </div>
                    <div class="drawer-cart-card__price">
                      ${formatMoney(item.final_line_price)}
                    </div>
                  </div>
                </div>
              </div>
            `).join('');
          }
        }

        const subtotalEl = document.querySelector('[data-cart-total]');
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

        let footer = document.querySelector('.drawer-cart-footer');
        if (cart.item_count === 0 && footer) {
          footer.style.display = 'none';
        } else if (cart.item_count > 0) {
          if (!footer) {
            const inner = document.querySelector('.cart-drawer-inner');
            if (inner) {
              const footDiv = document.createElement('div');
              footDiv.className = 'drawer-cart-footer';
              footDiv.innerHTML = `
                <div class="drawer-subtotal-row">
                  <span>Subtotal</span>
                  <strong data-cart-total>${formatMoney(cart.total_price)}</strong>
                </div>
                <p class="drawer-taxes-note">Taxes & shipping calculated at checkout</p>
                <a class="button button--checkout" href="/checkout">Proceed to Checkout →</a>
                <a class="button button--secondary" href="/cart">View full cart</a>`;
              inner.appendChild(footDiv);
            }
          } else {
            footer.style.display = 'block';
          }
        }
      });
  };

  document.addEventListener('click', e => {
    const btnQty = e.target.closest('[data-qty-change]');
    if (btnQty) {
      const delta = parseInt(btnQty.dataset.qtyChange, 10);
      const key = btnQty.dataset.key;
      const currentQty = parseInt(btnQty.dataset.qty, 10);
      const newQty = Math.max(0, currentQty + delta);

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      })
      .then(res => res.json())
      .then(() => refreshCartDrawer());
      return;
    }

    const btnRemove = e.target.closest('[data-cart-remove]');
    if (btnRemove) {
      const key = btnRemove.dataset.cartRemove;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
      .then(res => res.json())
      .then(() => refreshCartDrawer());
      return;
    }
  });

  // Product Form Submission
  document.addEventListener('submit', e => {
    const form = e.target;
    if (form && form.dataset && form.dataset.demandForm !== undefined) {
      e.preventDefault();
      const successMsg = form.querySelector('[data-demand-success]');
      const btn = form.querySelector('button[type="submit"]');
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Submitting...';
      }
      setTimeout(() => {
        if (btn) btn.textContent = 'Submitted ✓“';
        if (successMsg) successMsg.style.display = 'block';
        form.reset();
      }, 600);
      return;
    }

    if (form && form.action && form.action.includes('/cart/add')) {
      e.preventDefault();

      const btn = form.querySelector('button[type="submit"]');
      const origText = btn ? btn.textContent : '';
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Adding...';
      }

      const card = form.closest('.product-card') || form.closest('.product-main') || form.closest('.showcase-panel');
      const titleEl = card ? (card.querySelector('.product-title') || card.querySelector('h1') || card.querySelector('h3')) : null;
      const itemName = titleEl ? titleEl.textContent.trim() : 'Item';

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
      })
      .then(res => {
        if (!res.ok) {
          return res.json().then(data => { throw new Error(data.description || 'Add to cart failed'); });
        }
        return res.json();
      })
      .then(() => {
        if (btn) {
          btn.disabled = false;
          btn.textContent = 'Added ✓';
          setTimeout(() => { btn.textContent = origText; }, 2000);
        }
        refreshCartDrawer();
        showToast(itemName);
      })
      .catch(err => {
        console.error('Cart add error:', err);
        if (btn) {
          btn.disabled = false;
          btn.textContent = 'Try again';
          setTimeout(() => { btn.textContent = origText; }, 2000);
        }
      });
    }
  });

  // Guest & Direct Checkout Enabled (Zero login popups)

  /* --- INSTANT LIVE PREDICTIVE SEARCH ENGINE --- */
  const searchInputs = document.querySelectorAll('[data-predictive-input]');

  const escapeSearchHtml = (str) => {
    if (!str) return '';
    return String(str).replace(/[&<>"']/g, (m) => {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[m];
    });
  };

  searchInputs.forEach(input => {
    const form = input.closest('form');
    const container = form ? form.parentNode.querySelector('[data-predictive-results]') : null;
    const defaultSuggestions = form ? form.parentNode.querySelector('[data-default-suggestions]') : null;
    if (!container) return;

    let timer = null;

    const performPredictiveSearch = (query) => {
      const q = query.trim();
      if (!q) {
        container.style.display = 'none';
        container.innerHTML = '';
        if (defaultSuggestions) defaultSuggestions.style.display = 'flex';
        return;
      }

      if (defaultSuggestions) defaultSuggestions.style.display = 'none';
      container.style.display = 'block';
      container.innerHTML = `
        <div class="predictive-loading">
          <span class="predictive-spinner">â³</span>
          <span>Searching for "${escapeSearchHtml(q)}"...</span>
        </div>
      `;

      fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8`)
        .then(res => {
          if (!res.ok) throw new Error('Search failed');
          return res.json();
        })
        .then(data => {
          const products = data.resources?.results?.products || [];
          renderPredictiveResults(products, q, container);
        })
        .catch(() => {
          renderPredictiveFallback(q, container);
        });
    };

    const renderPredictiveResults = (products, q, target) => {
      if (products.length === 0) {
        target.innerHTML = `
          <div class="predictive-no-results">
            <p>No products found matching "<strong>${escapeSearchHtml(q)}</strong>"</p>
            <span class="predictive-tip">Try searching for Gajak, Chikki, Rewri, or Gift Boxes.</span>
          </div>
          <div class="predictive-footer">
            <a href="/search?q=${encodeURIComponent(q)}" class="predictive-view-all-btn">
              View all results for "${escapeSearchHtml(q)}" â†’
            </a>
          </div>
        `;
        return;
      }

      const itemsHtml = products.map(product => {
        const imageSrc = product.image || product.featured_image?.url || '';
        const rawPrice = product.price ? (parseFloat(product.price)).toFixed(0) : '';
        const formattedPrice = rawPrice ? `₹ ${rawPrice}` : '';

        return `
          <a href="${product.url}" class="predictive-item">
            <div class="predictive-item-media">
              ${imageSrc ? `<img src="${imageSrc}" alt="${escapeSearchHtml(product.title)}" loading="lazy">` : `<div class="predictive-no-img">ðŸ›ï¸</div>`}
            </div>
            <div class="predictive-item-info">
              <span class="predictive-item-title">${escapeSearchHtml(product.title)}</span>
              ${formattedPrice ? `<span class="predictive-item-price">${formattedPrice}</span>` : ''}
            </div>
            <span class="predictive-item-arrow">â†’</span>
          </a>
        `;
      }).join('');

      target.innerHTML = `
        <div class="predictive-header">
          <span>Instant Matches (${products.length})</span>
        </div>
        <div class="predictive-items-list">
          ${itemsHtml}
        </div>
        <div class="predictive-footer">
          <a href="/search?q=${encodeURIComponent(q)}" class="predictive-view-all-btn">
            View all results for "${escapeSearchHtml(q)}" â†’
          </a>
        </div>
      `;
    };

    const renderPredictiveFallback = (q, target) => {
      target.innerHTML = `
        <div class="predictive-footer">
          <a href="/search?q=${encodeURIComponent(q)}" class="predictive-view-all-btn">
            View all results for "${escapeSearchHtml(q)}" â†’
          </a>
        </div>
      `;
    };

    input.addEventListener('input', (e) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        performPredictiveSearch(e.target.value);
      }, 120);
    });

    input.addEventListener('focus', () => {
      if (input.value.trim()) {
        performPredictiveSearch(input.value);
      }
    });

    document.addEventListener('click', (e) => {
      if (form && !form.contains(e.target) && !container.contains(e.target)) {
        container.style.display = 'none';
      }
    });
  });

  // Account Drawer & Tab Management
  const accountDialog = document.querySelector('[data-account-dialog]');
  const accountLinks = document.querySelectorAll('.account-link, [data-account-open]');

  if (accountLinks.length && accountDialog) {
    accountLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        accountDialog.showModal();
      });
    });
  }

  const accountTabs = document.querySelectorAll('[data-account-tab]');
  if (accountTabs.length) {
    accountTabs.forEach(tab => {
      tab.addEventListener('click', () => {
        accountTabs.forEach(t => t.classList.remove('is-active'));
        tab.classList.add('is-active');
        const targetId = `account-tab-${tab.getAttribute('data-account-tab')}`;
        document.querySelectorAll('.account-drawer-tab-content').forEach(content => {
          if (content.id === targetId) {
            content.style.display = 'block';
            content.classList.add('is-active');
          } else {
            content.style.display = 'none';
            content.classList.remove('is-active');
          }
        });
      });
    });
  }
});

  // Pincode Delivery Checker Widget Logic with Spinner & Clean Text
  document.querySelectorAll("[data-pincode-checker]").forEach(checker => {
    const input = checker.querySelector("[data-pincode-input]");
    const submitBtn = checker.querySelector("[data-pincode-submit]");
    const resultBox = checker.querySelector("[data-pincode-result]");

    try { localStorage.removeItem("mahalaxmi_user_pincode"); } catch(e){}

    if (resultBox) {
      resultBox.style.display = "none";
      resultBox.innerHTML = "";
    }
    if (input) input.value = "";

    function doCheck() {
      if (!input || !resultBox) return;
      const pin = input.value.trim();

      if (!pin || !/^\d{6}$/.test(pin)) {
        resultBox.style.display = "block";
        resultBox.className = "pdp-pincode-result-clean is-error";
        resultBox.textContent = "Please enter a valid 6-digit pincode.";
        return;
      }

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = "Checking...";
      }
      resultBox.style.display = "block";
      resultBox.className = "pdp-pincode-result-clean is-loading";
      resultBox.innerHTML = "<span class=\"pin-spinner\"></span> Checking availability...";

      setTimeout(() => {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = "Check";
        }
        resultBox.className = "pdp-pincode-result-clean is-success";
        resultBox.textContent = "? Fast delivery available";
      }, 600);
    }

    if (submitBtn) {
      submitBtn.addEventListener("click", (e) => {
        e.preventDefault();
        doCheck();
      });
    }

    if (input) {
      input.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          doCheck();
        }
      });
    }
  });


/* ---- SMART REVEAL-ON-SCROLL-UP HEADER SCRIPT ---- */
(function() {
  let lastScrollY = window.scrollY;
  let ticking = false;
  const header = document.querySelector('.site-header');
  if (!header) return;

  const updateHeader = () => {
    const currentScrollY = window.scrollY;

    // Top of page threshold
    if (currentScrollY <= 80) {
      header.classList.remove('header--hidden');
      header.classList.remove('header--scrolled');
      lastScrollY = currentScrollY;
      ticking = false;
      return;
    }

    header.classList.add('header--scrolled');

    // Scrolling DOWN -> hide header
    if (currentScrollY > lastScrollY + 6) {
      header.classList.add('header--hidden');
    }
    // Scrolling UP -> reveal header immediately!
    else if (currentScrollY < lastScrollY - 6) {
      header.classList.remove('header--hidden');
    }

    lastScrollY = currentScrollY;
    ticking = false;
  };

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }, { passive: true });
})();

/* ---- AUTO LOGIN SYNC & OTP SESSION VERIFICATION ---- */
document.addEventListener("DOMContentLoaded", () => {
  const savedVerifiedPhone = (function(){ try { return localStorage.getItem('mahalaxmi_verified_phone'); } catch(e) { return null; } })();
  if (savedVerifiedPhone) {
    window.ShopifyCustomerLoggedIn = true;
    document.body.classList.add("customer-logged-in-session");
  }

  const phoneInput = document.getElementById("OTPPhoneNumberInput");
  const sendBtn = document.getElementById("OTPSendBtn");
  const step1 = document.getElementById("OTPStep1");
  const step2 = document.getElementById("OTPStep2");
  const sentDisplay = document.getElementById("OTPSentNumberDisplay");
  const editBtn = document.getElementById("OTPEditNumberBtn");
  const codeInput = document.getElementById("OTPCodeInput");
  const verifyBtn = document.getElementById("OTPVerifyBtn");
  const verifiedBadge = document.getElementById("OTPVerifiedBadge");
  const verifiedPhoneNum = document.getElementById("VerifiedPhoneNum");
  const errorMsg = document.getElementById("OTPErrorMsg");
  const successMsg = document.getElementById("OTPSuccessMsg");

  if (verifyBtn) {
    verifyBtn.addEventListener("click", () => {
      const code = codeInput ? codeInput.value.trim() : "";
      const phone = phoneInput ? phoneInput.value.trim() : "";
      if (!code || code.length < 4) {
        alert("Please enter the 4-digit OTP sent to your phone.");
        return;
      }
      // SAVE VERIFIED STATE TO LOCALSTORAGE SO USER IS LOGGED IN ACROSS WEBSITE
      try { localStorage.setItem('mahalaxmi_verified_phone', "+91" + phone); } catch(e) {};
      try { localStorage.setItem('mahalaxmi_user_logged_in', "true"); } catch(e) {};
      window.ShopifyCustomerLoggedIn = true;
      document.body.classList.add("customer-logged-in-session");

      if (step2) step2.style.display = "none";
      if (verifiedBadge) verifiedBadge.style.display = "flex";
      if (verifiedPhoneNum) verifiedPhoneNum.textContent = "+91 " + phone;
      if (successMsg) successMsg.style.display = "block";
    });
  }
});

/* ---- MAIN LOGIN PAGE MOBILE OTP AUTHENTICATION ---- */
document.addEventListener("DOMContentLoaded", () => {
  const phoneInput = document.getElementById("MainLoginPhone");
  const sendBtn = document.getElementById("MainLoginSendBtn");
  const step1 = document.getElementById("MainLoginOTPStep1");
  const step2 = document.getElementById("MainLoginOTPStep2");
  const phoneDisplay = document.getElementById("MainLoginPhoneDisplay");
  const editBtn = document.getElementById("MainLoginEditPhoneBtn");
  const codeInput = document.getElementById("MainLoginCode");
  const verifyBtn = document.getElementById("MainLoginVerifyBtn");
  const errorMsg = document.getElementById("MainLoginErrorMsg");
  const successMsg = document.getElementById("MainLoginSuccessMsg");

  if (!sendBtn || !phoneInput) return;

  sendBtn.addEventListener("click", () => {
    const num = phoneInput.value.trim();
    if (!/^[0-9]{10}$/.test(num)) {
      if (errorMsg) {
        errorMsg.style.display = "block";
        errorMsg.textContent = "Please enter a valid 10-digit mobile number.";
      }
      return;
    }
    if (errorMsg) errorMsg.style.display = "none";
    if (phoneDisplay) phoneDisplay.textContent = "+91 " + num;
    step1.style.display = "none";
    step2.style.display = "block";
  });

  if (editBtn) {
    editBtn.addEventListener("click", () => {
      step2.style.display = "none";
      step1.style.display = "block";
    });
  }

  if (verifyBtn) {
    verifyBtn.addEventListener("click", () => {
      const code = codeInput ? codeInput.value.trim() : "";
      const phone = phoneInput ? phoneInput.value.trim() : "";
      if (!code || code.length < 4) {
        alert("Please enter the 4-digit OTP sent to your mobile.");
        return;
      }
      try { localStorage.setItem('mahalaxmi_verified_phone', "+91" + phone); } catch(e) {};
      try { localStorage.setItem('mahalaxmi_user_logged_in', "true"); } catch(e) {};
      window.ShopifyCustomerLoggedIn = true;
      if (successMsg) successMsg.style.display = "block";
      setTimeout(() => {
        window.location.href = "/account";
      }, 800);
    });
  }
});

// ⚡ MAHALAXMI FAST CHECKOUT (OPTION 3 ACTIVE)
document.addEventListener('click', function(e) {
  const buyNowBtn = e.target.closest('.shopify-payment-button__button, [data-buy-now]');
  if (buyNowBtn) {
    e.preventDefault();
    e.stopPropagation();
    const form = buyNowBtn.closest('form');
    if (form) {
      const formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(res => res.json())
      .then(() => {
        window.location.href = '/checkout';
      })
      .catch(() => {
        window.location.href = '/checkout';
      });
    } else {
      window.location.href = '/checkout';
    }
  }
});














/* --- D2C MULTI-CHANNEL RESTOCK & INQUIRY ENGINE --- */
document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('RestockModalDialog');

  const dispatchToShopifyInboxAndAllChannels = (itemTitle, contactInfo, reqType = 'Restock Alert') => {
    const timestamp = new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' });

    // 1. Submit via Shopify Contact Form to guarantee instant email notification to store owner!
    try {
      const isEmail = contactInfo.includes('@');
      const cleanPhone = isEmail ? '' : contactInfo.replace(/[^0-9]/g, '');
      const validEmail = isEmail ? contactInfo : ('restock-' + (cleanPhone || 'customer') + '@mahalaxmigajak.com');

      const formData = new FormData();
      formData.append('form_type', 'contact');
      formData.append('utf8', '✓');
      formData.append('contact[tags]', 'restock_lead, notify_me');
      formData.append('contact[Request_Type]', 'Restock Alert Request');
      formData.append('contact[Product]', itemTitle);
      formData.append('contact[email]', validEmail);
      if (cleanPhone) {
        formData.append('contact[phone]', cleanPhone);
      }
      formData.append('contact[body]', '🔔 RESTOCK NOTIFICATION REQUEST:\n\nCustomer requested restock alert for product: ' + itemTitle + '\nCustomer Contact (WhatsApp / Email): ' + contactInfo + '\nDate & Time: ' + timestamp + '\n\nPlease notify this customer as soon as this item is back in stock.');

      fetch('/contact#contact_form', {
        method: 'POST',
        body: formData
      }).catch(err => {});
    } catch(e) {}

    // 2. LocalStorage Master Log
    try {
      const logs = JSON.parse(localStorage.getItem('mahalaxmi_customer_requests') || '[]');
      logs.unshift({ type: reqType, item: itemTitle, contact: contactInfo, time: timestamp });
      localStorage.setItem('mahalaxmi_customer_requests', JSON.stringify(logs));
    } catch(e) {}

    // 3. Shopify Cart Attributes for additional tracking
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            ['Customer Request - ' + itemTitle]: contactInfo + ' (' + timestamp + ')'
          }
        })
      }).catch(err => {});
    } catch(e) {}
  };

  // On-Site Merchant Request Viewer (Type ?view=requests in URL)
  if (window.location.search.includes('view=requests') || window.location.search.includes('admin=restock')) {
    const logs = JSON.parse(localStorage.getItem('mahalaxmi_customer_requests') || '[]');
    let rowsHtml = logs.length ? logs.map(l => `<tr style="border-bottom:1px solid #eee;"><td style="padding:10px;">${l.time}</td><td style="padding:10px;font-weight:bold;">${l.item}</td><td style="padding:10px;color:#d9381e;">${l.contact}</td></tr>`).join('') : '<tr><td colspan="3" style="padding:15px;text-align:center;">No customer requests logged yet.</td></tr>';

    const viewerHtml = `
      <div id="MerchantLogOverlay" style="position:fixed;inset:0;background:rgba(0,0,0,0.7);z-index:999999;display:flex;align-items:center;justify-content:center;padding:20px;">
        <div style="background:#fff;border-radius:16px;max-width:650px;width:100%;max-height:80vh;overflow-y:auto;padding:24px;box-shadow:0 20px 40px rgba(0,0,0,0.3);font-family:sans-serif;">
          <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:16px;">
            <h2 style="margin:0;font-size:20px;color:#111;">📋 All Customer Requests Log</h2>
            <button onclick="document.getElementById('MerchantLogOverlay').remove()" style="background:none;border:none;font-size:24px;cursor:pointer;">✕</button>
          </div>
          <table style="width:100%;border-collapse:collapse;text-align:left;font-size:14px;">
            <thead>
              <tr style="background:#f5f5f7;color:#555;">
                <th style="padding:10px;">Date & Time</th>
                <th style="padding:10px;">Product / Variant</th>
                <th style="padding:10px;">Customer Contact</th>
              </tr>
            </thead>
            <tbody>${rowsHtml}</tbody>
          </table>
          <button onclick="if(confirm('Clear all logs?')){localStorage.removeItem('mahalaxmi_customer_requests');location.reload();}" style="margin-top:16px;background:#ef3e2f;color:#fff;border:none;padding:8px 16px;border-radius:8px;cursor:pointer;font-weight:bold;">Clear Logs</button>
        </div>
      </div>
    `;
    document.body.insertAdjacentHTML('beforeend', viewerHtml);
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-trigger-restock-btn]');
    if (trigger) {
      e.preventDefault();
      
      const pRoot = trigger.closest('[data-product-root]');
      const selectedPill = pRoot?.querySelector('.option-pill.is-selected');
      const vTitle = selectedPill ? selectedPill.textContent.trim() : '';
      const pTitle = document.querySelector('.product-info h1')?.textContent.trim() || 'Product';
      const fullItemTitle = vTitle ? `${pTitle} (${vTitle})` : pTitle;

      // 1. IF LOGGED IN: Zero Popup! Direct 1-Click Registration + Trigger Shopify Inbox!
      if (window.isCustomerLoggedIn) {
        trigger.textContent = '✓ Alert Registered';
        trigger.style.background = '#00875a';
        trigger.style.color = '#ffffff';
        trigger.style.boxShadow = '0 4px 14px rgba(0, 135, 90, 0.35)';

        const contact = window.customerIdentifier || 'Logged In Customer';
        dispatchToShopifyInboxAndAllChannels(fullItemTitle, contact);

        // Show sleek notification toast
        const toast = document.getElementById('CartDropdownToast');
        if (toast) {
          const toastName = toast.querySelector('[data-toast-item-name]');
          if (toastName) toastName.textContent = `✓ Restock request saved for ${fullItemTitle}!`;
          toast.classList.add('is-active');
          setTimeout(() => toast.classList.remove('is-active'), 3500);
        } else {
          alert(`✓ Restock request saved for ${fullItemTitle}!`);
        }
        return; // STOP HERE - NO MODAL POPUP FOR LOGGED IN USERS!
      }

      // 2. IF GUEST USER: Open Mobile Number Modal
      if (!modal) return;
      const titleEl = modal.querySelector('[data-restock-product-title]');
      const formWrap = modal.querySelector('[data-restock-form-wrap]');
      const successAlert = modal.querySelector('[data-restock-success-alert]');

      if (titleEl) titleEl.textContent = fullItemTitle;
      if (formWrap) formWrap.style.display = 'block';
      if (successAlert) successAlert.style.display = 'none';

      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        modal.setAttribute('open', 'true');
      }
    }
  });

  if (!modal) return;
  const closeBtn = modal.querySelector('[data-close-restock-modal]');
  const formWrap = modal.querySelector('[data-restock-form-wrap]');
  const successAlert = modal.querySelector('[data-restock-success-alert]');
  const phoneInput = modal.querySelector('[data-restock-phone-input]');
  const titleEl = modal.querySelector('[data-restock-product-title]');
  const guestSubmitBtn = modal.querySelector('[data-submit-restock-guest]');

  closeBtn?.addEventListener('click', () => {
    if (typeof modal.close === 'function') {
      modal.close();
    } else {
      modal.removeAttribute('open');
    }
  });

  const handleRestockSuccess = (contactInfo) => {
    if (formWrap) formWrap.style.display = 'none';
    if (successAlert) successAlert.style.display = 'block';

    const itemTitle = titleEl?.textContent || 'Product';
    dispatchToShopifyInboxAndAllChannels(itemTitle, contactInfo);

    setTimeout(() => {
      if (typeof modal.close === 'function') {
        modal.close();
      } else {
        modal.removeAttribute('open');
      }
    }, 2500);
  };

  guestSubmitBtn?.addEventListener('click', () => {
    const phone = phoneInput?.value.trim() || '';
    if (!phone || !/^[0-9]{10}$/.test(phone)) {
      alert('Please enter a valid 10-digit mobile number.');
      phoneInput?.focus();
      return;
    }

    if (guestSubmitBtn) guestSubmitBtn.textContent = '✓ Registered!';
    handleRestockSuccess(phone);
  });
});

  /* AJAX NEWSLETTER HANDLER (Shopify Admin Customers & Marketing Automation Trigger) */
document.querySelectorAll('.newsletter-form').forEach(form => {
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    e.stopPropagation();
    const input = form.querySelector('input[type="email"]');
    const submitBtn = form.querySelector('button[type="submit"]');
    const email = input ? input.value.trim() : '';
    if (!email) return;

    const originalBtnText = submitBtn ? submitBtn.textContent : 'Join the family';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Subscribing...';
    }

    // Build URL-encoded form data so Shopify Admin Customers registers the subscriber and triggers Marketing Automations
    const params = new URLSearchParams();
    params.append('form_type', 'customer');
    params.append('utf8', '✓');
    params.append('contact[tags]', 'newsletter, website_subscriber');
    params.append('contact[email]', email);

    fetch('/contact#contact_form', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8'
      },
      body: params.toString()
    }).then(() => {
      if (input) input.value = '';
      if (submitBtn) {
        submitBtn.textContent = '✓ Subscribed!';
        submitBtn.style.background = '#00875a';
        setTimeout(() => {
          submitBtn.disabled = false;
          submitBtn.textContent = originalBtnText;
          submitBtn.style.background = '';
        }, 4000);
      }
    }).catch(() => {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = originalBtnText;
      }
    });

    return false;
  });
});




/* --- DESKTOP & MOBILE MEGA MENU HOVER & CLICK ENGINE --- */
(function() {
  function initMegaNavigation() {
    const item = document.querySelector('.nav-item--mega');
    const link = item ? item.querySelector(':scope > .nav-link') : null;
    const menu = document.querySelector('.mega-menu');
    const header = document.querySelector('.site-header');
    const toggle = document.querySelector('[data-menu-toggle]');
    const nav = document.querySelector('[data-nav]');
    if (!item || !menu) return;

    let hoverTimer = null;
    const isDesktop = () => window.innerWidth >= 990;

    const openDesktop = () => {
      if (!isDesktop()) return;
      clearTimeout(hoverTimer);
      item.classList.add('is-mega-open');
      if (header) header.classList.add('has-mega-open');
      if (link) link.setAttribute('aria-expanded', 'true');
    };

    const closeDesktop = () => {
      if (!isDesktop()) return;
      item.classList.remove('is-mega-open');
      if (header) header.classList.remove('has-mega-open');
      if (link) link.setAttribute('aria-expanded', 'false');
    };

    const delayClose = () => {
      if (!isDesktop()) return;
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(closeDesktop, 450); // 450ms safety buffer
    };

    // Desktop hover bindings (Strictly desktop only)
    item.addEventListener('mouseenter', openDesktop);
    item.addEventListener('mouseleave', delayClose);

    if (link) {
      link.addEventListener('mouseenter', openDesktop);
      link.addEventListener('mouseleave', delayClose);
    }

    menu.addEventListener('mouseenter', openDesktop);
    menu.addEventListener('mouseleave', delayClose);

    if (header) {
      header.addEventListener('mouseleave', delayClose);
    }

    // Mobile click on "Products" toggles accordion
    if (link) {
      link.addEventListener('click', (e) => {
        if (!isDesktop()) {
          e.preventDefault();
          e.stopPropagation();
          const open = item.classList.toggle('is-mega-open');
          link.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
      });
    }

    // Close menu when clicking sublinks on mobile or desktop
    menu.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        if (isDesktop()) {
          closeDesktop();
        } else {
          item.classList.remove('is-mega-open');
          if (nav) nav.classList.remove('open');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        }
      });
    });

    // Close on click outside
    document.addEventListener('click', (e) => {
      if (isDesktop()) {
        if (!item.contains(e.target) && !menu.contains(e.target)) {
          closeDesktop();
        }
      } else {
        if (nav && nav.classList.contains('open')) {
          if (!nav.contains(e.target) && !toggle.contains(e.target)) {
            nav.classList.remove('open');
            if (toggle) toggle.setAttribute('aria-expanded', 'false');
          }
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaNavigation);
  } else {
    initMegaNavigation();
  }
})();
